export default async (response: any) => response;
